var render = function render(_c,_vm){return _c('footer',{staticClass:"the-footer flex-wrap justify-between",class:_vm.classes},[_vm._m(0),_vm._m(1)])
}
var staticRenderFns = [function (_c,_vm){return _c('p',[_c('span',[_c('strong',[_vm._v("Copyright © 2015-2016 Bitwave Inc")]),_vm._v(" All rights reserved. Powered by ZioTes")])])
},function (_c,_vm){return _c('span',{staticClass:"md:flex hidden items-center"},[_c('span',[_vm._v("Version 1.0")])])
}]

export { render, staticRenderFns }